import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { scrollToId } from "shared/helpers";

export const AccordionSection = ({
    arrowOnly,
    children,
    isOpen,
    label,
    loadOnOpen,
    onClick,
    anchor,
    stretchBody = false,
    enableSeparator = true,
    hidden,
    titleClasses = "",
}) => {
    const icon = isOpen ? faChevronDown : faChevronRight;
    const showChildren = loadOnOpen ? isOpen : true;

    useEffect(() => {
        if (window.location.hash && anchor && window.location.hash === `#${anchor}`) {
            scrollToId(window.location.hash.replace("#", ""));
        }
    }, [anchor]);

    const labelClick = (event) => {
        if (arrowOnly) {
            event.stopPropagation();
        }
    };

    return (
        <div
            style={{ display: hidden ? "none" : "block" }}
            id={anchor}
            className="accordion-section"
        >
            <div
                className={`accordion-title -clickable ${titleClasses}`}
                onClick={onClick}
            >
                <div className="icon">
                    <button type="button">
                        <FontAwesomeIcon icon={icon} />
                    </button>
                </div>
                <div
                    className={classnames("label", { "-clickable": !arrowOnly, "-underscore": enableSeparator })}
                    onClick={labelClick}
                >
                    {label}
                </div>
                {enableSeparator && <div className="empty-space" />}
            </div>
            <div className={classnames("accordion-content", { "-active": isOpen, "-stretch": stretchBody })}>{showChildren && children}</div>
        </div>
    );
};

const Accordion = (props) => {
    const [openArr, setOpenArr] = useState(
        props.openAll ? props.children.map((c, i) => i) : props.startingIndexes ? props.startingIndexes : [props.startingIndex]
    );
    useEffect(() => {
        setOpenArr(props.openAll ? props.children.map((c, i) => i) : props.startingIndexes ? props.startingIndexes : [props.startingIndex]);
    }, [props.startingIndex, props.startingIndexes, props.children.length]);

    // TODO: this is a turbo hack, refactor!
    const children = Array.isArray(props.children) ? props.children : [props.children];

    const sections = children.map((child, i) => {
        return (
            <AccordionSection
                {...props}
                hidden={child.props.hidden}
                anchor={child.props.anchor}
                arrowOnly={props.arrowOnly}
                key={`accordionSection-${i}`}
                isOpen={openArr.includes(i)}
                label={child.props.label}
                loadOnOpen={props.loadOnOpen}
                onClick={() => {
                    const newOpenArr = openArr.includes(i) ? openArr.filter((o) => o !== i) : props.closeInactive ? [i] : [...openArr, i];
                    setOpenArr(newOpenArr);
                }}
            >
                {child}
            </AccordionSection>
        );
    });
    const className = props.className ? `${props.className} accordion` : "accordion";

    return (
        <div
            style={props.style}
            className={className}
        >
            {sections}
        </div>
    );
};

Accordion.defaultProps = {
    arrowOnly: false,
    closeInactive: false,
    loadOnOpen: false,
    openAll: false,
    startingIndex: -1,
};

export default Accordion;
